import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS].GET_IN_PROGRESS_FIELD_WORKS]:{
    url:'/company/:companyId/done_works/in_progress_field_works/'
  }
}